import React from 'react'

export function Loading({className = '', text='Carregando...'}:{className?:string, text?:string}){
    return <div className={`text-muted ${className}`}><i className="fa fa-spin fa-circle-notch"></i> {text}</div>
}